module.exports = __webpack_public_path__ + "img/نرم-ولطیف.f577eb39.png";